"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SZ_000151_1DAY_MINUTE = {
    "code": 0,
    "stock": [{
        "time": 150000,
        "date": 20240920,
        "symbol": "000151.sz",
        "name": "000151.sz",
        "minute": [{
            "price": 10.31,
            "open": 10.31,
            "low": 10.31,
            "high": 10.31,
            "vol": 152200,
            "amount": 1569182,
            "time": 925
        }, {
            "price": 10.34,
            "open": 10.34,
            "low": 10.34,
            "high": 10.34,
            "vol": 649100,
            "amount": 6544445,
            "time": 930
        }, {
            "price": 10.39,
            "open": 10.39,
            "low": 10.39,
            "high": 10.39,
            "vol": 206400,
            "amount": 2127510,
            "time": 931
        }, {
            "price": 10.45,
            "open": 10.45,
            "low": 10.45,
            "high": 10.45,
            "vol": 235400,
            "amount": 2245766,
            "time": 932
        }, {
            "price": 10.36,
            "open": 10.36,
            "low": 10.36,
            "high": 10.36,
            "vol": 183700,
            "amount": 1886200,
            "time": 933
        }, {
            "price": 10.38,
            "open": 10.38,
            "low": 10.38,
            "high": 10.38,
            "vol": 260200,
            "amount": 2689752,
            "time": 934
        }, {
            "price": 10.32,
            "open": 10.32,
            "low": 10.32,
            "high": 10.32,
            "vol": 284500,
            "amount": 2797673,
            "time": 935
        }, {
            "price": 10.31,
            "open": 10.31,
            "low": 10.31,
            "high": 10.31,
            "vol": 189500,
            "amount": 1892777,
            "time": 936
        }, {
            "price": 10.34,
            "open": 10.34,
            "low": 10.34,
            "high": 10.34,
            "vol": 118400,
            "amount": 1177892,
            "time": 937
        }, {
            "price": 10.27,
            "open": 10.27,
            "low": 10.27,
            "high": 10.27,
            "vol": 292100,
            "amount": 2834582,
            "time": 938
        }, {
            "price": 10.29,
            "open": 10.29,
            "low": 10.29,
            "high": 10.29,
            "vol": 209400,
            "amount": 2081065,
            "time": 939
        }, {
            "price": 10.27,
            "open": 10.27,
            "low": 10.27,
            "high": 10.27,
            "vol": 236100,
            "amount": 2403700,
            "time": 940
        }, {
            "price": 10.29,
            "open": 10.29,
            "low": 10.29,
            "high": 10.29,
            "vol": 164400,
            "amount": 1637394,
            "time": 941
        }, {
            "price": 10.33,
            "open": 10.33,
            "low": 10.33,
            "high": 10.33,
            "vol": 125900,
            "amount": 1300557,
            "time": 942
        }, {
            "price": 10.31,
            "open": 10.31,
            "low": 10.31,
            "high": 10.31,
            "vol": 148200,
            "amount": 1445009,
            "time": 943
        }, {
            "price": 10.3,
            "open": 10.3,
            "low": 10.3,
            "high": 10.3,
            "vol": 417000,
            "amount": 4104336,
            "time": 944
        }, {
            "price": 10.28,
            "open": 10.28,
            "low": 10.28,
            "high": 10.28,
            "vol": 77600,
            "amount": 770952,
            "time": 945
        }, {
            "price": 10.31,
            "open": 10.31,
            "low": 10.31,
            "high": 10.31,
            "vol": 118700,
            "amount": 1211801,
            "time": 946
        }, {
            "price": 10.29,
            "open": 10.29,
            "low": 10.29,
            "high": 10.29,
            "vol": 53400,
            "amount": 547444,
            "time": 947
        }, {
            "price": 10.31,
            "open": 10.31,
            "low": 10.31,
            "high": 10.31,
            "vol": 105900,
            "amount": 1064015,
            "time": 948
        }, {
            "price": 10.32,
            "open": 10.32,
            "low": 10.32,
            "high": 10.32,
            "vol": 24500,
            "amount": 252884,
            "time": 949
        }, {
            "price": 10.3,
            "open": 10.3,
            "low": 10.3,
            "high": 10.3,
            "vol": 54400,
            "amount": 550391,
            "time": 950
        }, {
            "price": 10.28,
            "open": 10.28,
            "low": 10.28,
            "high": 10.28,
            "vol": 140100,
            "amount": 1360550,
            "time": 951
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 176800,
            "amount": 1891802,
            "time": 952
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 254200,
            "amount": 2277452,
            "time": 953
        }, {
            "price": 10.27,
            "open": 10.27,
            "low": 10.27,
            "high": 10.27,
            "vol": 93800,
            "amount": 932527,
            "time": 954
        }, {
            "price": 10.26,
            "open": 10.26,
            "low": 10.26,
            "high": 10.26,
            "vol": 107700,
            "amount": 1187589,
            "time": 955
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 32000,
            "amount": 319049,
            "time": 956
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 74100,
            "amount": 762606,
            "time": 957
        }, {
            "price": 10.24,
            "open": 10.24,
            "low": 10.24,
            "high": 10.24,
            "vol": 54000,
            "amount": 536782,
            "time": 958
        }, {
            "price": 10.24,
            "open": 10.24,
            "low": 10.24,
            "high": 10.24,
            "vol": 64800,
            "amount": 711952,
            "time": 959
        }, {
            "price": 10.23,
            "open": 10.23,
            "low": 10.23,
            "high": 10.23,
            "vol": 120100,
            "amount": 1206447,
            "time": 1000
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 156300,
            "amount": 1560698,
            "time": 1001
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 73500,
            "amount": 746975,
            "time": 1002
        }, {
            "price": 10.24,
            "open": 10.24,
            "low": 10.24,
            "high": 10.24,
            "vol": 71500,
            "amount": 728711,
            "time": 1003
        }, {
            "price": 10.26,
            "open": 10.26,
            "low": 10.26,
            "high": 10.26,
            "vol": 38000,
            "amount": 364911,
            "time": 1004
        }, {
            "price": 10.31,
            "open": 10.31,
            "low": 10.31,
            "high": 10.31,
            "vol": 62500,
            "amount": 623869,
            "time": 1005
        }, {
            "price": 10.27,
            "open": 10.27,
            "low": 10.27,
            "high": 10.27,
            "vol": 52900,
            "amount": 517258,
            "time": 1006
        }, {
            "price": 10.27,
            "open": 10.27,
            "low": 10.27,
            "high": 10.27,
            "vol": 35200,
            "amount": 333736,
            "time": 1007
        }, {
            "price": 10.27,
            "open": 10.27,
            "low": 10.27,
            "high": 10.27,
            "vol": 32800,
            "amount": 314153,
            "time": 1008
        }, {
            "price": 10.26,
            "open": 10.26,
            "low": 10.26,
            "high": 10.26,
            "vol": 61500,
            "amount": 623738,
            "time": 1009
        }, {
            "price": 10.24,
            "open": 10.24,
            "low": 10.24,
            "high": 10.24,
            "vol": 106700,
            "amount": 1120298,
            "time": 1010
        }, {
            "price": 10.23,
            "open": 10.23,
            "low": 10.23,
            "high": 10.23,
            "vol": 52300,
            "amount": 511701,
            "time": 1011
        }, {
            "price": 10.23,
            "open": 10.23,
            "low": 10.23,
            "high": 10.23,
            "vol": 205300,
            "amount": 1958964,
            "time": 1012
        }, {
            "price": 10.24,
            "open": 10.24,
            "low": 10.24,
            "high": 10.24,
            "vol": 149600,
            "amount": 1533868,
            "time": 1013
        }, {
            "price": 10.27,
            "open": 10.27,
            "low": 10.27,
            "high": 10.27,
            "vol": 74100,
            "amount": 591490,
            "time": 1014
        }, {
            "price": 10.26,
            "open": 10.26,
            "low": 10.26,
            "high": 10.26,
            "vol": 13900,
            "amount": 69791,
            "time": 1015
        }, {
            "price": 10.26,
            "open": 10.26,
            "low": 10.26,
            "high": 10.26,
            "vol": 68100,
            "amount": 698548,
            "time": 1016
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 66700,
            "amount": 683275,
            "time": 1017
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 45000,
            "amount": 471196,
            "time": 1018
        }, {
            "price": 10.27,
            "open": 10.27,
            "low": 10.27,
            "high": 10.27,
            "vol": 15800,
            "amount": 151774,
            "time": 1019
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 51000,
            "amount": 553599,
            "time": 1020
        }, {
            "price": 10.24,
            "open": 10.24,
            "low": 10.24,
            "high": 10.24,
            "vol": 28800,
            "amount": 289833,
            "time": 1021
        }, {
            "price": 10.23,
            "open": 10.23,
            "low": 10.23,
            "high": 10.23,
            "vol": 29600,
            "amount": 326573,
            "time": 1022
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 99200,
            "amount": 996659,
            "time": 1023
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 32700,
            "amount": 321949,
            "time": 1024
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 23500,
            "amount": 240153,
            "time": 1025
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 35900,
            "amount": 361737,
            "time": 1026
        }, {
            "price": 10.25,
            "open": 10.25,
            "low": 10.25,
            "high": 10.25,
            "vol": 66300,
            "amount": 678952,
            "time": 1027
        }, {
            "price": 10.23,
            "open": 10.23,
            "low": 10.23,
            "high": 10.23,
            "vol": 39700,
            "amount": 402153,
            "time": 1028
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 132300,
            "amount": 1304273,
            "time": 1029
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 40500,
            "amount": 418886,
            "time": 1030
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 124700,
            "amount": 940153,
            "time": 1031
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 31900,
            "amount": 298128,
            "time": 1032
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 49300,
            "amount": 548358,
            "time": 1033
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 26400,
            "amount": 269770,
            "time": 1034
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 40000,
            "amount": 406895,
            "time": 1035
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 61100,
            "amount": 615320,
            "time": 1036
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 57000,
            "amount": 579994,
            "time": 1037
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 81400,
            "amount": 823205,
            "time": 1038
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 74000,
            "amount": 754780,
            "time": 1039
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 90700,
            "amount": 864063,
            "time": 1040
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 49400,
            "amount": 491189,
            "time": 1041
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 92700,
            "amount": 827719,
            "time": 1042
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 18600,
            "amount": 154903,
            "time": 1043
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 7700,
            "amount": 89760,
            "time": 1044
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 43500,
            "amount": 410881,
            "time": 1045
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 14400,
            "amount": 146770,
            "time": 1046
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 59700,
            "amount": 550224,
            "time": 1047
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 87400,
            "amount": 829106,
            "time": 1048
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 34600,
            "amount": 350376,
            "time": 1049
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 15500,
            "amount": 158089,
            "time": 1050
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 9300,
            "amount": 60169,
            "time": 1051
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 46600,
            "amount": 471008,
            "time": 1052
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 700,
            "amount": 7142,
            "time": 1053
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 15300,
            "amount": 163278,
            "time": 1054
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 3800,
            "amount": 38764,
            "time": 1055
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 2300,
            "amount": 23474,
            "time": 1056
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 10200,
            "amount": 104116,
            "time": 1057
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 33200,
            "amount": 316177,
            "time": 1058
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 13700,
            "amount": 128491,
            "time": 1059
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 20500,
            "amount": 206059,
            "time": 1100
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 47600,
            "amount": 485209,
            "time": 1101
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 21400,
            "amount": 205846,
            "time": 1102
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 23700,
            "amount": 241708,
            "time": 1103
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 33600,
            "amount": 322074,
            "time": 1104
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 25600,
            "amount": 261100,
            "time": 1105
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 23700,
            "amount": 240503,
            "time": 1106
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 42900,
            "amount": 431055,
            "time": 1107
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 47200,
            "amount": 467736,
            "time": 1108
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 21100,
            "amount": 241314,
            "time": 1109
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 12500,
            "amount": 127271,
            "time": 1110
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 25400,
            "amount": 248501,
            "time": 1111
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 6100,
            "amount": 62164,
            "time": 1112
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 22600,
            "amount": 236288,
            "time": 1113
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 34800,
            "amount": 350145,
            "time": 1114
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 11800,
            "amount": 120092,
            "time": 1115
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 13500,
            "amount": 140505,
            "time": 1116
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 15800,
            "amount": 160927,
            "time": 1117
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 9800,
            "amount": 99844,
            "time": 1118
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 24300,
            "amount": 247544,
            "time": 1119
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 12600,
            "amount": 129339,
            "time": 1120
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 20900,
            "amount": 209649,
            "time": 1121
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 17100,
            "amount": 174129,
            "time": 1122
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 16300,
            "amount": 171221,
            "time": 1123
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 17600,
            "amount": 179424,
            "time": 1124
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 60600,
            "amount": 590516,
            "time": 1125
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 22700,
            "amount": 212499,
            "time": 1126
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 25300,
            "amount": 258545,
            "time": 1127
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 20700,
            "amount": 224717,
            "time": 1128
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 19400,
            "amount": 197900,
            "time": 1129
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 0,
            "amount": 0,
            "time": 1130
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 67900,
            "amount": 658329,
            "time": 1300
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 18200,
            "amount": 191388,
            "time": 1301
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 226300,
            "amount": 2232202,
            "time": 1302
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 55300,
            "amount": 584985,
            "time": 1303
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 32600,
            "amount": 330773,
            "time": 1304
        }, {
            "price": 10.13,
            "open": 10.13,
            "low": 10.13,
            "high": 10.13,
            "vol": 43900,
            "amount": 418125,
            "time": 1305
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 20900,
            "amount": 211041,
            "time": 1306
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 26200,
            "amount": 255582,
            "time": 1307
        }, {
            "price": 10.12,
            "open": 10.12,
            "low": 10.12,
            "high": 10.12,
            "vol": 70800,
            "amount": 767879,
            "time": 1308
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 29700,
            "amount": 300832,
            "time": 1309
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 54800,
            "amount": 557374,
            "time": 1310
        }, {
            "price": 10.13,
            "open": 10.13,
            "low": 10.13,
            "high": 10.13,
            "vol": 42600,
            "amount": 430680,
            "time": 1311
        }, {
            "price": 10.13,
            "open": 10.13,
            "low": 10.13,
            "high": 10.13,
            "vol": 17700,
            "amount": 179386,
            "time": 1312
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 23700,
            "amount": 266849,
            "time": 1313
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 15200,
            "amount": 154454,
            "time": 1314
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 37500,
            "amount": 339311,
            "time": 1315
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 6500,
            "amount": 65975,
            "time": 1316
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 23600,
            "amount": 239553,
            "time": 1317
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 41400,
            "amount": 420040,
            "time": 1318
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 11700,
            "amount": 125998,
            "time": 1319
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 21900,
            "amount": 222567,
            "time": 1320
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 7000,
            "amount": 71069,
            "time": 1321
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 9600,
            "amount": 97489,
            "time": 1322
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 27900,
            "amount": 262289,
            "time": 1323
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 8800,
            "amount": 87318,
            "time": 1324
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 34800,
            "amount": 324846,
            "time": 1325
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 10000,
            "amount": 101465,
            "time": 1326
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 48200,
            "amount": 488967,
            "time": 1327
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 13300,
            "amount": 134986,
            "time": 1328
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 17500,
            "amount": 177579,
            "time": 1329
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 23900,
            "amount": 237516,
            "time": 1330
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 12000,
            "amount": 121800,
            "time": 1331
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 33800,
            "amount": 306543,
            "time": 1332
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 4300,
            "amount": 43617,
            "time": 1333
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 37400,
            "amount": 380427,
            "time": 1334
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 22900,
            "amount": 231428,
            "time": 1335
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 39100,
            "amount": 363737,
            "time": 1336
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 48800,
            "amount": 495662,
            "time": 1337
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 2500,
            "amount": 25385,
            "time": 1338
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 3500,
            "amount": 35555,
            "time": 1339
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 7100,
            "amount": 72076,
            "time": 1340
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 11500,
            "amount": 116749,
            "time": 1341
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 19500,
            "amount": 171535,
            "time": 1342
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 21800,
            "amount": 185835,
            "time": 1343
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 11900,
            "amount": 120820,
            "time": 1344
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 25900,
            "amount": 249997,
            "time": 1345
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 7000,
            "amount": 73288,
            "time": 1346
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 63800,
            "amount": 649114,
            "time": 1347
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 8900,
            "amount": 90360,
            "time": 1348
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 13300,
            "amount": 133284,
            "time": 1349
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 4000,
            "amount": 40733,
            "time": 1350
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 24200,
            "amount": 238187,
            "time": 1351
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 132100,
            "amount": 1347356,
            "time": 1352
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 6200,
            "amount": 62940,
            "time": 1353
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 2400,
            "amount": 24362,
            "time": 1354
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 9000,
            "amount": 90376,
            "time": 1355
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 15000,
            "amount": 152304,
            "time": 1356
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 13600,
            "amount": 138134,
            "time": 1357
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 26500,
            "amount": 269090,
            "time": 1358
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 6200,
            "amount": 62964,
            "time": 1359
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 6100,
            "amount": 83304,
            "time": 1400
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 22500,
            "amount": 243891,
            "time": 1401
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 19500,
            "amount": 198047,
            "time": 1402
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 5900,
            "amount": 59908,
            "time": 1403
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 9900,
            "amount": 99553,
            "time": 1404
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 16900,
            "amount": 183861,
            "time": 1405
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 4200,
            "amount": 42714,
            "time": 1406
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 36700,
            "amount": 362835,
            "time": 1407
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 9300,
            "amount": 94395,
            "time": 1408
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 8800,
            "amount": 89404,
            "time": 1409
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 13000,
            "amount": 132002,
            "time": 1410
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 16400,
            "amount": 166461,
            "time": 1411
        }, {
            "price": 10.11,
            "open": 10.11,
            "low": 10.11,
            "high": 10.11,
            "vol": 367100,
            "amount": 3691214,
            "time": 1412
        }, {
            "price": 10.11,
            "open": 10.11,
            "low": 10.11,
            "high": 10.11,
            "vol": 170500,
            "amount": 1692783,
            "time": 1413
        }, {
            "price": 10.12,
            "open": 10.12,
            "low": 10.12,
            "high": 10.12,
            "vol": 231200,
            "amount": 2333358,
            "time": 1414
        }, {
            "price": 10.12,
            "open": 10.12,
            "low": 10.12,
            "high": 10.12,
            "vol": 43500,
            "amount": 420057,
            "time": 1415
        }, {
            "price": 10.13,
            "open": 10.13,
            "low": 10.13,
            "high": 10.13,
            "vol": 28800,
            "amount": 289690,
            "time": 1416
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 30100,
            "amount": 305604,
            "time": 1417
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 28500,
            "amount": 301804,
            "time": 1418
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 10800,
            "amount": 106583,
            "time": 1419
        }, {
            "price": 10.14,
            "open": 10.14,
            "low": 10.14,
            "high": 10.14,
            "vol": 12200,
            "amount": 123778,
            "time": 1420
        }, {
            "price": 10.15,
            "open": 10.15,
            "low": 10.15,
            "high": 10.15,
            "vol": 24800,
            "amount": 252818,
            "time": 1421
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 15400,
            "amount": 156355,
            "time": 1422
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 7200,
            "amount": 73150,
            "time": 1423
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 18800,
            "amount": 188145,
            "time": 1424
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 35400,
            "amount": 346803,
            "time": 1425
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 9000,
            "amount": 91581,
            "time": 1426
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 21500,
            "amount": 217722,
            "time": 1427
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 7600,
            "amount": 77379,
            "time": 1428
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 71000,
            "amount": 726828,
            "time": 1429
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 35900,
            "amount": 352655,
            "time": 1430
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 43100,
            "amount": 438876,
            "time": 1431
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 12600,
            "amount": 128153,
            "time": 1432
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 36900,
            "amount": 359530,
            "time": 1433
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 23400,
            "amount": 240024,
            "time": 1434
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 12500,
            "amount": 121023,
            "time": 1435
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 48400,
            "amount": 492291,
            "time": 1436
        }, {
            "price": 10.16,
            "open": 10.16,
            "low": 10.16,
            "high": 10.16,
            "vol": 39500,
            "amount": 391539,
            "time": 1437
        }, {
            "price": 10.17,
            "open": 10.17,
            "low": 10.17,
            "high": 10.17,
            "vol": 55000,
            "amount": 544015,
            "time": 1438
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 67100,
            "amount": 672546,
            "time": 1439
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 41900,
            "amount": 416586,
            "time": 1440
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 35000,
            "amount": 397250,
            "time": 1441
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 24900,
            "amount": 250369,
            "time": 1442
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 56300,
            "amount": 601678,
            "time": 1443
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 23500,
            "amount": 206404,
            "time": 1444
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 79400,
            "amount": 802126,
            "time": 1445
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 41300,
            "amount": 419534,
            "time": 1446
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 64000,
            "amount": 632395,
            "time": 1447
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 91100,
            "amount": 909242,
            "time": 1448
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 72400,
            "amount": 739248,
            "time": 1449
        }, {
            "price": 10.21,
            "open": 10.21,
            "low": 10.21,
            "high": 10.21,
            "vol": 54100,
            "amount": 542917,
            "time": 1450
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 196500,
            "amount": 1861803,
            "time": 1451
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 146900,
            "amount": 1453544,
            "time": 1452
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 54800,
            "amount": 645911,
            "time": 1453
        }, {
            "price": 10.2,
            "open": 10.2,
            "low": 10.2,
            "high": 10.2,
            "vol": 44800,
            "amount": 446374,
            "time": 1454
        }, {
            "price": 10.18,
            "open": 10.18,
            "low": 10.18,
            "high": 10.18,
            "vol": 114300,
            "amount": 1102701,
            "time": 1455
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 145600,
            "amount": 1385550,
            "time": 1456
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 0,
            "amount": 0,
            "time": 1457
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 0,
            "amount": 0,
            "time": 1458
        }, {
            "price": 10.19,
            "open": 10.19,
            "low": 10.19,
            "high": 10.19,
            "vol": 0,
            "amount": 0,
            "time": 1459
        }, {
            "price": 10.22,
            "open": 10.22,
            "low": 10.22,
            "high": 10.22,
            "vol": 194100,
            "amount": 2104298,
            "time": 1500
        }],
        "yclose": 10.46,
        "limitprice": {
            "max": 11.51,
            "min": 9.41
        }
    }]

    /*暴露外部用的方法*/
};exports.SZ_000151_1DAY_MINUTE = SZ_000151_1DAY_MINUTE;


//////////////////
// WEBPACK FOOTER
// ./~/hqchart/src/jscommon/umychart.vue.testdataV2/DayMinute/000151.sz.1day.minute.js
// module id = 321
// module chunks = 0